import { render, staticRenderFns } from "./WarningIndex.vue?vue&type=template&id=5ca35485&scoped=true"
import script from "./WarningIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarningIndex.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WarningIndex.vue?vue&type=style&index=0&id=5ca35485&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca35485",
  null
  
)

export default component.exports